import styled from 'styled-components';
import {withStyles} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import InputBase from '@material-ui/core/InputBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ListSubheader from '@material-ui/core/ListSubheader';
import {getDirectionStyles} from '../../utils/ThemeUtils';

import {AutocompleteListProps} from './types';

export const StyledSearchInput = withStyles(theme => ({
    root: {
        borderRadius: '4px',

        '& > .MuiInputAdornment-positionStart': {
            padding: theme.spacing(0, 2),

            '& svg': {
                fontSize: '20px'
            }
        },
        '& > .MuiInputAdornment-positionEnd': {
            padding: 0
        }
    },
    input: {
        height: '40px'
    },
    focused: {
        backgroundColor: theme.palette.grey['800']
    }
}))(InputBase);

export const StyledAutocomplete = withStyles<string, undefined, AutocompleteListProps>(theme => ({
    groupLabel: {
        // @ts-ignore
        backgroundColor: theme.palette.background.overlays,
        paddingLeft: theme.spacing(4),
        fontWeight: 400,
        lineHeight: '40px'
    },
    listbox: {
        padding: 0,
        maxHeight: 'unset',
        marginTop: theme.spacing(-2),
        direction: `${theme.direction} !important` as typeof theme.direction,

        '& > ul': {
            margin: 0,
            paddingInlineStart: 0
        }
    },
    option: {
        alignItems: 'center',
        minHeight: 0,

        padding: getDirectionStyles(theme.direction)(
            theme.spacing(2, 2, 2, 4),
            theme.spacing(2, 4, 2, 2)
        ),

        fontWeight: 400,

        '&[aria-selected="true"]': {
            backgroundColor: 'initial'
        },

        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.16)'
        }
    }
}))(Autocomplete);

export const ClearButton = withStyles({
    root: {
        padding: 0,
        marginRight: '6px',

        minWidth: '30px',
        minHeight: '30px',

        // Clear button
        '& svg': {
            fontSize: '1.2rem'
        }
    }
})(Button);

export const InputContainer = styled.div`
    padding: ${p => p.theme.muiTheme.spacing(0, 2)};
    margin-bottom: ${p => p.theme.muiTheme.spacing(2)}px;
`;

export const StyledListSubheader = withStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        height: theme.spacing(8),
        width: '100%',
        padding: theme.spacing(0, 4),

        ...theme.typography.caption
    }
}))(ListSubheader);
